import { render } from "./sh-bread-item.vue?vue&type=template&id=24c2c95e"
import script from "./sh-bread-item.vue?vue&type=script&lang=js"
export * from "./sh-bread-item.vue?vue&type=script&lang=js"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__